<template>
  <div>
    <p>The experiment will launch in fullscreen mode when you click the button below.</p>
    <button
      class="btn btn-secondary"
      @click="launch()">Launch Experiment</button>
      <!-- comment in below to test sentry hookup -->
      <!-- button @click="throwError">Throw error</button -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import screenfull from 'screenfull'
import State from '../mixins/State'
export default {
  mixins: [ State ],
  methods: {
    ...mapActions(['start']),
    launch () {
      this.start()
      if (screenfull.enabled) { // launch in fullscreen if possible
        screenfull.request()
      }
      this.$router.replace('/instructions/1') // go to instructions state
    },
    throwError() {
      throw new Error('Sentry Error');
    }
  }
}
</script>
